/**
 * @generated SignedSource<<421be7da4be824cc6019a5a42c22d5b8>>
 * @relayHash b49c8a3ac73a21e67a68640caa6b4428
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b49c8a3ac73a21e67a68640caa6b4428

import { ConcreteRequest } from 'relay-runtime';
export type de_BetterDocExchangeOperation = "CONFIRM_RECOMMENDATION_RESULTS" | "CONFIRM_SELECTED_MEDICS" | "CREATE_RECOMMENDATION" | "GET_RECOMMENDATION" | "LIST_RECOMMENDATIONS" | "LIST_RECOMMENDED_RECOMMENDATIONS" | "LIST_SELECTED_RECOMMENDATIONS" | "SEARCH_CARE_PROVIDERS" | "SELECT_MEDIC" | "SEND_REFERRAL_SLIP" | "SIMULATE_PATIENT_SELECTION" | "SIMULATE_RESEARCH" | "SIMULATE_SECOND_OPINION_VISIT_CONFIRMATION";
export type de_BetterDocExchangeOutcome = "CANCELLED" | "FAILED" | "PENDING" | "RESPONDED" | "TIMED_OUT" | "TOKEN_UNAVAILABLE";
export type betterDocExchangeQuery$variables = {
  exchangeId: number;
};
export type betterDocExchangeQuery$data = {
  readonly de_betterDocExchange: {
    readonly exchange: {
      readonly actor: string;
      readonly completedAt: string | null;
      readonly durationMilliseconds: number | null;
      readonly exchangeId: number;
      readonly failureKind: string | null;
      readonly hasUnexpectedResponse: boolean;
      readonly httpMethod: string;
      readonly isTestCase: boolean;
      readonly operation: de_BetterDocExchangeOperation;
      readonly outcome: de_BetterDocExchangeOutcome;
      readonly patientId: string | null;
      readonly progressNoteId: number | null;
      readonly requestUri: any;
      readonly responseStatusCode: number | null;
      readonly startedAt: string;
    };
    readonly requestBody: string | null;
    readonly requestContentType: string | null;
    readonly requestHeaders: string | null;
    readonly responseBody: string | null;
    readonly responseContentType: string | null;
    readonly responseHeaders: string | null;
    readonly sessionIds: ReadonlyArray<number>;
    readonly traceParent: string | null;
  } | null;
};
export type betterDocExchangeQuery = {
  response: betterDocExchangeQuery$data;
  variables: betterDocExchangeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "exchangeId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "exchangeId",
        "variableName": "exchangeId"
      }
    ],
    "concreteType": "de_BetterDocExchangeDetail",
    "kind": "LinkedField",
    "name": "de_betterDocExchange",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocExchangeSummary",
        "kind": "LinkedField",
        "name": "exchange",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "exchangeId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "operation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "httpMethod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requestUri",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTestCase",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasUnexpectedResponse",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseStatusCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationMilliseconds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "outcome",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "failureKind",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "patientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "progressNoteId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "traceParent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requestHeaders",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requestContentType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requestBody",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "responseHeaders",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "responseContentType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "responseBody",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sessionIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "betterDocExchangeQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "betterDocExchangeQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "b49c8a3ac73a21e67a68640caa6b4428",
    "metadata": {},
    "name": "betterDocExchangeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8e404e58aaff2e62ba81d2c2082a9e4e";

export default node;
